import { useState, useEffect } from "react";
import ToggleSwitch from "./ToggleSwitch";
import "../admin/pages/styles/LightSwitch.css";
import axios from "axios";

import ArrowDown from "/assets/ArrowDown.svg";
import Delete from "/Delete1.png?url";

import { Bar } from "react-chartjs-2";
import "chart.js/auto";

import { Stepper, Step, StepLabel, styled } from "@mui/material";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";

// สไตล์สำหรับ StepConnector
const CustomConnector = styled(StepConnector)(({ theme, activeStep }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
  },
  [`&.${stepConnectorClasses.line}`]: {
    borderColor: activeStep === 0 ? "#E4E7EC" : "#2762F8", // สีเส้นที่ต่างกันตาม step
    borderTopWidth: 2,
    borderRadius: 1,
  },
  ...(activeStep === 1 && {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#2762F8", // สีเส้นเมื่อ active
    },
  }),
}));

const CustomStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#2762F8",
  width: 20,
  height: 20,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundColor: "#2762F8",
  }),
  ...(ownerState.completed && {
    backgroundColor: "#2762F8",
  }),
}));

function CustomStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <div></div>, // ไอคอนที่ต้องการแสดง
    2: <div></div>,
  };

  return (
    <CustomStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(props.icon)]}
    </CustomStepIconRoot>
  );
}

function AddPoleModal({ isVisible, onClose, onSave }) {
  const [page, setPage] = useState(1);
  const [selectedPoleType, setSelectedPoleType] = useState("main");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [timeInputs, setTimeInputs] = useState([]);
  const [cctvs, setCctvs] = useState([]);
  const [leds, setLeds] = useState([]);
  const [isAddingLED, setIsAddingLED] = useState(false);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [poles, setPoles] = useState([]);
  const [selectedPoles, setSelectedPoles] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleBranchClick = (branch) => {
    setSelectedBranch({
      id: branch.id,
      name: branch.name,
      code: branch.code,
    });
    setDropdownOpen(false); // Close dropdown when a branch is selected
    console.log(`Selected branch: ${branch.name}, ID: ${branch.id}`);
  };

  const handlePolesClick = (pole) => {
    setSelectedPoles({
      id: pole.id,
      name: pole.name,
      code: pole.code,
      branch_id: pole.branch_id,
    });
    setDropdownOpen(false); // Close dropdown when a pole is selected
    console.log(`Selected pole: ${pole.name}, ID: ${pole.id}`);
  };

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_API_URL}/api/branches`
        );
        setBranches(response.data); // Axios automatically unwraps the data property
      } catch (error) {
        console.error("Error fetching branches:", error);
      }
    };

    fetchBranches();
  }, []);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPolesData = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_API_URL}/allMainPoles`
        );
        setPoles(response.data.mainPoles || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        setPoles([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPolesData();
  }, []);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const getToggleStateMessage = () => {
    const currentActiveStatus =
      selectedPoleType === "main"
        ? mainPoleData.active
        : secondaryPoleData.active;
    if (currentActiveStatus) {
      return {
        message: "เปิดใช้งานสาขา",
        style: { color: "#3DCC85" },
      };
    } else {
      return {
        message: "ยังไม่เปิดใช้งานสาขา",
        style: { color: "#F2274C" },
      };
    }
  };

  const handleAddLED = () => {
    const newLed = { name: "", model: "", installationDate: "" };
    setLeds([...leds, newLed]);
    setIsAddingLED(true);
  };

  const handleLEDChange = (index, field, value) => {
    const updatedLEDs = leds.map((led, i) =>
      i === index ? { ...led, [field]: value } : led
    );
    setLeds(updatedLEDs);
  };

  const handleDeleteLED = (index) => {
    const newLEDs = [...leds];
    newLEDs.splice(index, 1);
    setLeds(newLEDs);
    setIsAddingLED(false);
  };

  const handleAddCCTV = () => {
    const newCctv = {
      name: "",
      model: "",
      installationDate: "",
      isActive: false, // เปลี่ยนเป็น false ถ้าต้องการให้ค่าเริ่มต้นเป็นปิดใช้งาน
    };
    setCctvs((cctvs) => [...cctvs, newCctv]);
  };

  const handleToggleCCTVActive = (index) => {
    setCctvs((prevCctvs) => {
      const updatedCctvs = [...prevCctvs];
      updatedCctvs[index] = {
        ...updatedCctvs[index],
        isActive: !updatedCctvs[index].isActive,
      };
      console.log(
        `Camera ${index + 1} isActive toggled to: ${
          updatedCctvs[index].isActive
        }`
      );
      return updatedCctvs;
    });
  };

  const handleCCTVChange = (index, field, value) => {
    const updatedCCTVs = cctvs.map((cctv, i) =>
      i === index ? { ...cctv, [field]: value } : cctv
    );
    setCctvs(updatedCCTVs);
  };

  const [mainPoleData, setMainPoleData] = useState({
    poleCode: "",
    poleName: "",
    deviceCode: "",
    firmwareVersion: "",
    installationDate: "",
    poleLocation: "",
    latitude: "",
    longitude: "",
    active: false,
    schedule_light_bulbs_rule: 1,
  });

  const [secondaryPoleData, setSecondaryPoleData] = useState({
    poleCode: "",
    poleName: "",
    deviceCode: "",
    firmwareVersion: "",
    installationDate: "",
    poleLocation: "",
    latitude: "",
    longitude: "",
    active: false,
    schedule_light_bulbs_rule: 1,
  });

  const handleDeleteCCTV = (index) => {
    const newCCTVs = [...cctvs];
    newCCTVs.splice(index, 1);
    setCctvs(newCCTVs);
  };

  const handleMainPoleChange = (name, value) => {
    setMainPoleData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSecondaryPoleChange = (field, value) => {
    setSecondaryPoleData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleBrightnessChange = (event) => {
    const newRule = event.target.checked ? 2 : 1;
    if (selectedPoleType === "main") {
      setMainPoleData((prev) => ({
        ...prev,
        schedule_light_bulbs_rule: newRule,
      }));
    } else {
      setSecondaryPoleData((prev) => ({
        ...prev,
        schedule_light_bulbs_rule: newRule,
      }));
    }
  };

  const handleAddTimeClick = (event) => {
    event.preventDefault();
    const newInput = {
      id: Date.now(),
      rangeValue: 0,
      timeValue: "",
    };
    setTimeInputs(timeInputs.concat(newInput));
  };

  const handleRangeChange = (id, newValue) => {
    setTimeInputs(
      timeInputs.map((input) => {
        if (input.id === id) {
          return { ...input, rangeValue: newValue };
        }
        return input;
      })
    );
  };

  const handleRemoveTimeInput = (idToRemove) => {
    let newTimeInputs = timeInputs.filter((input) => input.id !== idToRemove);
    setTimeInputs(newTimeInputs);
  };

  function timeToMinutes(timeValue) {
    const [hours, minutes] = timeValue.split(":").map(Number);
    return hours * 60 + minutes;
  }

  const sortedTimeInputs = [...timeInputs].sort((a, b) => {
    const timeA = a.timeValue ? timeToMinutes(a.timeValue) : Infinity;
    const timeB = b.timeValue ? timeToMinutes(b.timeValue) : Infinity;
    return timeA - timeB;
  });

  function minutesToTime(minutes) {
    if (minutes < 0) {
      minutes = 23 * 60 + 59;
    }
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}`;
  }

  const labels = sortedTimeInputs.map((input, index) => {
    if (index < sortedTimeInputs.length - 1) {
      const nextTimeInMinutes =
        timeToMinutes(sortedTimeInputs[index + 1].timeValue) - 1;
      const adjustedNextTime = minutesToTime(nextTimeInMinutes);
      return `${input.timeValue} - ${adjustedNextTime}`;
    } else {
      const firstTimeInMinutes =
        timeToMinutes(sortedTimeInputs[0].timeValue) - 1;
      const adjustedFirstTime = minutesToTime(firstTimeInMinutes);
      return `${input.timeValue} - ${adjustedFirstTime}`;
    }
  });

  const chartData = {
    labels,
    datasets: [
      {
        data: sortedTimeInputs.map((input) => input.rangeValue),
        backgroundColor: "#F5B81C",
      },
    ],
  };

  const handleTimeChange = (id, newTimeValue) => {
    setTimeInputs(
      timeInputs.map((input) =>
        input.id === id ? { ...input, timeValue: newTimeValue } : input
      )
    );
  };

  const handleConfirmButtonClick = () => {
    setPage(2);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleCancelClick = () => {
    setPage(1);
  };

  const handlePoleTypeClick = (type) => {
    setSelectedPoleType(type);
    console.log(`Selected pole type: ${type}`);
  };

  const handleToggleChange = (index, value) => {
    const updatedLEDs = leds.map((led, idx) => {
      if (idx === index) {
        return { ...led, has_screen: value };
      }
      return led;
    });
    setLeds(updatedLEDs);
  };

  const options = {
    scales: {
      x: {
        ticks: {
          color: "white",
        },
        grid: {
          color: "transparent",
        },
      },
      y: {
        position: "right",
        beginAtZero: true,
        ticks: {
          color: "white",
          callback: function (value) {
            return value + "%";
          },
        },
        min: 0,
        max: 100,
        grid: {
          color: "rgba(255, 255, 255, 0.1)",
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
    maintainAspectRatio: false,
    responsive: true,
  };

  const renderFloatLabelInput = (
    label,
    type,
    name,
    id,
    value,
    onChange,
    required = true
  ) => (
    <div className="float-label-container">
      <input
        type={type}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        className="input-required"
        required={required}
        placeholder=" "
      />
      <label htmlFor={id}>
        {label} {required && <span className="required-asterisk"> *</span>}
      </label>
    </div>
  );

  const handleSubmit = async () => {
    const is_master = selectedPoleType === "main";
    const branch_id = is_master ? selectedBranch.id : selectedPoles.branch_id;

    const poleData =
      selectedPoleType === "main" ? mainPoleData : secondaryPoleData;

    const postData = {
      branch_id: branch_id,
      master_id: is_master ? null : selectedPoles.id,
      is_master: is_master,
      code: poleData.poleCode,
      name: poleData.poleName,
      hardware_id: poleData.deviceCode,
      firmware_version: poleData.firmwareVersion,
      installation_date: poleData.installationDate || null,
      location: poleData.poleLocation,
      lat: parseFloat(poleData.latitude),
      lng: parseFloat(poleData.longitude),
      active: poleData.active,
      has_screen: leds[0]?.has_screen || false,
      last_dim: null,
      screen_id: leds[0]?.name,
      screen_model: leds[0]?.model,
      screen_installation_date: leds[0]?.installationDate || null,
      schedule_light_bulbs_rule: poleData.schedule_light_bulbs_rule,
      custom_schedule_light_bulbs_active: true,
      latest_schedule_light_bulbs_period: null,
      latest_schedule_light_bulbs_brightness: null,
      latest_schedule_light_bulbs_on: null,
      schedule_light_bulbs: timeInputs.map((input) => ({
        period: input.timeValue,
        brightness: input.rangeValue,
      })),
      cameras: cctvs, // ส่งข้อมูลกล้องทั้งหมดไปในคราวเดียว
    };

    try {
      // ส่งข้อมูลเสาและกล้องทั้งหมด
      const response = await axios.post(
        `${import.meta.env.VITE_API_URL}/add-polemaster`,
        postData
      );

      console.log("Successfully added pole with cameras:", response.data);

      setIsModalOpen(false);
      onClose();
      onSave();
    } catch (error) {
      console.error(
        "Failed to add new pole:",
        error.response ? error.response.data : error.message
      );
    }
    console.log(postData);
  };

  return (
    <>
      <div className="BranchModal">
        <div className="BranchModalContent">
          <h2>เพิ่มเสาหลัก/เสารอง</h2>

          <div className="statebranch">
            <Stepper
              className="stepper"
              activeStep={page - 1}
              alternativeLabel
              connector={<CustomConnector activeStep={page - 1} />} // ส่ง activeStep เข้าไปใน CustomConnector
            >
              <Step key="1">
                <StepLabel StepIconComponent={CustomStepIcon}>
                  เพิ่มข้อมูลเสา
                </StepLabel>
              </Step>
              <Step key="2">
                <StepLabel StepIconComponent={CustomStepIcon}>
                  ตรวจสอบข้อมูลเสา
                </StepLabel>
              </Step>
            </Stepper>
          </div>
          <div className="lightswitch">
            <button
              onClick={() => handlePoleTypeClick("main")}
              style={{
                transform:
                  selectedPoleType === "main" ? "translateY(-3px)" : "",
                color: selectedPoleType === "main" ? "#7DA1FB" : "",
                borderBottom:
                  selectedPoleType === "main" ? "2px solid #7DA1FB" : "",
              }}
            >
              เสาหลัก
            </button>
            <button
              onClick={() => handlePoleTypeClick("secondary")}
              style={{
                transform:
                  selectedPoleType === "secondary" ? "translateY(-3px)" : "",
                color: selectedPoleType === "secondary" ? "#7DA1FB" : "",
                borderBottom:
                  selectedPoleType === "secondary" ? "2px solid #7DA1FB" : "",
              }}
            >
              เสารอง
            </button>
          </div>

          {selectedPoleType === "main" && (
            <div>
              <form className="addlight">
                <label>เพิ่มข้อมูลเสาหลัก</label>
                <div
                  className="selectLight"
                  onClick={toggleDropdown}
                  style={{
                    borderColor: dropdownOpen
                      ? "#2762f8"
                      : "defaultBorderColor",
                    borderWidth: dropdownOpen ? "2px" : "",
                    borderStyle: "solid",
                  }}
                >
                  <span>{selectedBranch ? selectedBranch.name : "สาขา"}</span>
                  <img
                    className={`arrow-icon-branch ${
                      dropdownOpen ? "rotated" : ""
                    }`}
                    src={ArrowDown}
                    alt="Arrow"
                  />
                  {dropdownOpen && (
                    <div className="dropdown-content-branchAll">
                      <div className="notBlur">
                        <ul>
                          {branches.map((branch) => (
                            <li
                              key={branch.id}
                              onClick={() => handleBranchClick(branch)}
                            >
                              <div className="gridBranchAll">
                                <p className="codeBranchName">{branch.name}</p>
                                <p className="codeBranch">{branch.code}</p>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>

                {renderFloatLabelInput(
                  "รหัสเสา ",
                  "text",
                  "poleCode",
                  "poleCode",
                  mainPoleData.poleCode,
                  (e) => handleMainPoleChange("poleCode", e.target.value)
                )}
                {renderFloatLabelInput(
                  "ชื่อเสา ",
                  "text",
                  "poleName",
                  "poleName",
                  mainPoleData.poleName,
                  (e) => handleMainPoleChange("poleName", e.target.value)
                )}
                {renderFloatLabelInput(
                  "รหัสอุปกรณ์ ",
                  "text",
                  "deviceCode",
                  "deviceCode",
                  mainPoleData.deviceCode,
                  (e) => handleMainPoleChange("deviceCode", e.target.value)
                )}
                {renderFloatLabelInput(
                  "เวอร์ชั่น Firmware ",
                  "text",
                  "firmwareVersion",
                  "firmwareVersion",
                  mainPoleData.firmwareVersion,
                  (e) => handleMainPoleChange("firmwareVersion", e.target.value)
                )}
                {renderFloatLabelInput(
                  "วันที่ติดตั้งเสา ",
                  "date",
                  "installationDate",
                  "installationDate",
                  mainPoleData.installationDate,
                  (e) =>
                    handleMainPoleChange("installationDate", e.target.value)
                )}
                {renderFloatLabelInput(
                  "สถานที่ติดตั้งเสา",
                  "text",
                  "poleLocation",
                  "poleLocation",
                  mainPoleData.poleLocation,
                  (e) => handleMainPoleChange("poleLocation", e.target.value)
                )}
                {renderFloatLabelInput(
                  "ละติจูด",
                  "text",
                  "latitude",
                  "latitude",
                  mainPoleData.latitude,
                  (e) => handleMainPoleChange("latitude", e.target.value)
                )}
                {renderFloatLabelInput(
                  "ลองจิจูด",
                  "text",
                  "longitude",
                  "longitude",
                  mainPoleData.longitude,
                  (e) => handleMainPoleChange("longitude", e.target.value)
                )}
                <div className="toggle-switch-container">
                  <span>
                    {mainPoleData.active
                      ? "เปิดการใช้งานสาขา"
                      : "ปิดการใช้งานสาขา"}
                  </span>
                  <label className="toggle-switch">
                    <input
                      type="checkbox"
                      checked={mainPoleData.active}
                      onChange={(e) =>
                        setMainPoleData({
                          ...mainPoleData,
                          active: e.target.checked,
                        })
                      }
                    />
                    <span className="slider"></span>
                  </label>
                </div>

                <label>ปรับความสว่างไฟแบบอัตโนมัติ</label>
                <div className="toggle-switch-container">
                  <span>
                    {mainPoleData.schedule_light_bulbs_rule === 1
                      ? "ค่าเริ่มต้น"
                      : "กำหนดเอง"}
                  </span>
                  <label className="toggle-switch">
                    <input
                      type="checkbox"
                      checked={mainPoleData.schedule_light_bulbs_rule === 2}
                      onChange={(e) => {
                        const newRule = e.target.checked ? 2 : 1;
                        setMainPoleData((prev) => ({
                          ...prev,
                          schedule_light_bulbs_rule: newRule,
                        }));
                      }}
                    />
                    <span className="slider"></span>
                  </label>
                </div>
                {mainPoleData.schedule_light_bulbs_rule === 2 && (
                  <div className="add-time-button-container">
                    <button
                      className="add-time-button"
                      onClick={handleAddTimeClick}
                    >
                      + เพิ่มเวลา
                    </button>
                  </div>
                )}
              </form>
              {mainPoleData.schedule_light_bulbs_rule === 2 &&
                timeInputs.map((input, index) => (
                  <div key={input.id} className="time-input-container">
                    <label>เวลา</label>
                    <input
                      type="time"
                      className="time-display"
                      value={input.timeValue}
                      onChange={(e) =>
                        handleTimeChange(input.id, e.target.value)
                      }
                    />
                    <div
                      className="slider-container"
                      style={{ position: "relative" }}
                    >
                      <input
                        type="range"
                        min="0"
                        max="100"
                        value={input.rangeValue}
                        className="gradient-range"
                        onChange={(e) =>
                          handleRangeChange(input.id, e.target.value)
                        }
                      />
                      <div
                        className="value-display"
                        style={{
                          left: `calc(${input.rangeValue}% + 10px)`,
                          transform: "translateX(-50%)",
                          bottom: "-15px",
                        }}
                      >
                        {input.rangeValue}%
                      </div>
                    </div>
                    <button
                      className="delete-button"
                      onClick={() => handleRemoveTimeInput(input.id)}
                    >
                      <img src={Delete} alt="Delete" />
                    </button>
                  </div>
                ))}
              {mainPoleData.schedule_light_bulbs_rule === 2 &&
                timeInputs.some((input) => input.timeValue) && (
                  <div className="setlight chartContainer">
                    <Bar data={chartData} options={options} />
                  </div>
                )}
              <hr />
              <div className="addCctv">
                <h2>กล้อง CCTV</h2>
                <form className="addlight">
                  {cctvs.map((cctv, index) => (
                    <div key={index}>
                      {renderFloatLabelInput(
                        "ชื่อกล้อง",
                        "text",
                        `name-${index}`,
                        `name-${index}`,
                        cctv.name,
                        (e) => handleCCTVChange(index, "name", e.target.value)
                      )}
                      {renderFloatLabelInput(
                        "รุ่นกล้อง",
                        "text",
                        `model-${index}`,
                        `model-${index}`,
                        cctv.model,
                        (e) => handleCCTVChange(index, "model", e.target.value)
                      )}
                      {renderFloatLabelInput(
                        "วันที่ติดตั้ง",
                        "date",
                        `installationDate-${index}`,
                        `installationDate-${index}`,
                        cctv.installationDate,
                        (e) =>
                          handleCCTVChange(
                            index,
                            "installationDate",
                            e.target.value
                          )
                      )}
                      <div className="flexAddCCtv">
                        <div className="toggle-switch-container">
                          <span>เปิดใช้งานกล้อง</span>

                          <label className="toggle-switch">
                            <input
                              type="checkbox"
                              checked={cctv.isActive}
                              onChange={() => handleToggleCCTVActive(index)}
                            />
                            <span className="slider"></span>
                          </label>
                        </div>
                        <button
                          className="delete-button"
                          onClick={() => handleDeleteCCTV(index)}
                        >
                          <img src={Delete} alt="Delete" />
                        </button>
                      </div>
                    </div>
                  ))}
                </form>
                <button id="addCctvButton" onClick={handleAddCCTV}>
                  + เพิ่มกล้อง CCTV
                </button>
              </div>
              <hr />
              <div className="addLed">
                <h2>จอ LED</h2>
                <form className="addlight">
                  {leds.map((led, index) => (
                    <div key={index} className="led-item">
                      {renderFloatLabelInput(
                        "รหัสจอ",
                        "text",
                        `name-${index}`,
                        `name-${index}`,
                        led.name,
                        (e) => handleLEDChange(index, "name", e.target.value)
                      )}
                      {renderFloatLabelInput(
                        "รุ่นจอ",
                        "text",
                        `model-${index}`,
                        `model-${index}`,
                        led.model,
                        (e) => handleLEDChange(index, "model", e.target.value)
                      )}
                      {renderFloatLabelInput(
                        "วันที่ติดตั้ง",
                        "date",
                        `installationDate-${index}`,
                        `installationDate-${index}`,
                        led.installationDate,
                        (e) =>
                          handleLEDChange(
                            index,
                            "installationDate",
                            e.target.value
                          )
                      )}
                      <div className="flexAddCCtv">
                        <div className="toggle-switch-container">
                          <span>เปิดใช้งานกล้อง</span>
                          <label className="toggle-switch">
                            <input
                              type="checkbox"
                              checked={led.has_screen}
                              onChange={(e) =>
                                handleToggleChange(index, e.target.checked)
                              }
                            />
                            <span className="slider"></span>
                          </label>
                        </div>
                        <button
                          className="delete-button"
                          onClick={() => handleDeleteLED(index)}
                        >
                          <img src={Delete} alt="Delete" />
                        </button>
                      </div>
                    </div>
                  ))}
                  {!isAddingLED && (
                    <button id="addLedButton" onClick={handleAddLED}>
                      + เพิ่มจอ LED
                    </button>
                  )}
                </form>
              </div>
            </div>
          )}
          {selectedPoleType === "secondary" && (
            <div>
              <form className="addlight">
                <label>เพิ่มข้อมูลเสารอง</label>
                <div
                  className="selectLight"
                  onClick={toggleDropdown}
                  style={{
                    borderColor: dropdownOpen
                      ? "#2762f8"
                      : "defaultBorderColor",
                    borderWidth: dropdownOpen ? "2px" : "",
                    borderStyle: "solid",
                  }}
                >
                  <span>{selectedPoles.name || "เลือกเสาหลัก"}</span>
                  <img
                    className={`arrow-icon-branch ${
                      dropdownOpen ? "rotated" : ""
                    }`}
                    src={ArrowDown}
                    alt="Arrow"
                  />
                  {dropdownOpen && (
                    <div className="dropdown-content-branchAll">
                      <div className="notBlur">
                        {loading ? (
                          <p>Loading...</p>
                        ) : (
                          <ul>
                            {poles.map((pole) => (
                              <li
                                key={pole.id}
                                onClick={() => handlePolesClick(pole)}
                              >
                                <div className="gridBranchAll">
                                  <p className="codeBranchName">{pole.name}</p>
                                  <p className="codeBranch">{pole.code}</p>
                                </div>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                {renderFloatLabelInput(
                  "รหัสเสา ",
                  "text",
                  "poleCodeSecondary",
                  "poleCodeSecondary",
                  secondaryPoleData.poleCode,
                  (e) => handleSecondaryPoleChange("poleCode", e.target.value)
                )}
                {renderFloatLabelInput(
                  "ชื่อเสา ",
                  "text",
                  "poleNameSecondary",
                  "poleNameSecondary",
                  secondaryPoleData.poleName,
                  (e) => handleSecondaryPoleChange("poleName", e.target.value)
                )}
                {renderFloatLabelInput(
                  "รหัสอุปกรณ์ ",
                  "text",
                  "deviceCodeSecondary",
                  "deviceCodeSecondary",
                  secondaryPoleData.deviceCode,
                  (e) => handleSecondaryPoleChange("deviceCode", e.target.value)
                )}
                {renderFloatLabelInput(
                  "เวอร์ชั่น Firmware ",
                  "text",
                  "firmwareVersionSecondary",
                  "firmwareVersionSecondary",
                  secondaryPoleData.firmwareVersion,
                  (e) =>
                    handleSecondaryPoleChange("firmwareVersion", e.target.value)
                )}
                {renderFloatLabelInput(
                  "วันที่ติดตั้งเสา ",
                  "date",
                  "installationDateSecondary",
                  "installationDateSecondary",
                  secondaryPoleData.installationDate,
                  (e) =>
                    handleSecondaryPoleChange(
                      "installationDate",
                      e.target.value
                    )
                )}
                {renderFloatLabelInput(
                  "สถานที่ติดตั้งเสา",
                  "text",
                  "poleLocationSecondary",
                  "poleLocationSecondary",
                  secondaryPoleData.poleLocation,
                  (e) =>
                    handleSecondaryPoleChange("poleLocation", e.target.value)
                )}
                {renderFloatLabelInput(
                  "ละติจูด",
                  "text",
                  "latitudeSecondary",
                  "latitudeSecondary",
                  secondaryPoleData.latitude,
                  (e) => handleSecondaryPoleChange("latitude", e.target.value)
                )}
                {renderFloatLabelInput(
                  "ลองจิจูด",
                  "text",
                  "longitudeSecondary",
                  "longitudeSecondary",
                  secondaryPoleData.longitude,
                  (e) => handleSecondaryPoleChange("longitude", e.target.value)
                )}
                <div className="toggle-switch-container">
                  <span>
                    {secondaryPoleData.active
                      ? "เปิดการใช้งานสาขา"
                      : "ปิดการใช้งานสาขา"}
                  </span>
                  <label className="toggle-switch">
                    <input
                      type="checkbox"
                      checked={secondaryPoleData.active}
                      onChange={(e) =>
                        setSecondaryPoleData({
                          ...secondaryPoleData,
                          active: e.target.checked,
                        })
                      }
                    />
                    <span className="slider"></span>
                  </label>
                </div>
                <label>ปรับความสว่างไฟแบบอัตโนมัติ</label>
                <div className="toggle-switch-container">
                  <span>
                    {secondaryPoleData.schedule_light_bulbs_rule === 1
                      ? "ค่าเริ่มต้น"
                      : "กำหนดเอง"}
                  </span>
                  <label className="toggle-switch">
                    <input
                      type="checkbox"
                      checked={
                        secondaryPoleData.schedule_light_bulbs_rule === 2
                      }
                      onChange={(e) => {
                        const newRule = e.target.checked ? 2 : 1;
                        setSecondaryPoleData((prev) => ({
                          ...prev,
                          schedule_light_bulbs_rule: newRule,
                        }));
                      }}
                    />
                    <span className="slider"></span>
                  </label>
                </div>
                {secondaryPoleData.schedule_light_bulbs_rule === 2 && (
                  <div className="add-time-button-container">
                    <button
                      className="add-time-button"
                      onClick={handleAddTimeClick}
                    >
                      + เพิ่มเวลา
                    </button>
                  </div>
                )}
              </form>
              {secondaryPoleData.schedule_light_bulbs_rule === 2 &&
                timeInputs.map((input, index) => (
                  <div key={input.id} className="time-input-container">
                    <label>เวลา</label>
                    <input
                      type="time"
                      className="time-display"
                      value={input.timeValue}
                      onChange={(e) =>
                        handleTimeChange(input.id, e.target.value)
                      }
                    />
                    <div
                      className="slider-container"
                      style={{ position: "relative" }}
                    >
                      <input
                        type="range"
                        min="0"
                        max="100"
                        value={input.rangeValue}
                        className="gradient-range"
                        onChange={(e) =>
                          handleRangeChange(input.id, e.target.value)
                        }
                      />
                      <div
                        className="value-display"
                        style={{
                          left: `calc(${input.rangeValue}% + 10px)`,
                          transform: "translateX(-50%)",
                          bottom: "-15px",
                        }}
                      >
                        {input.rangeValue}%
                      </div>
                    </div>
                    <button
                      className="delete-button"
                      onClick={() => handleRemoveTimeInput(input.id)}
                    >
                      <img src={Delete} alt="Delete" />
                    </button>
                  </div>
                ))}
              {secondaryPoleData.schedule_light_bulbs_rule === 2 &&
                timeInputs.some((input) => input.timeValue) && (
                  <div className="setlight chartContainer">
                    <Bar data={chartData} options={options} />
                  </div>
                )}
              <hr />
              <div className="addCctv">
                <h2>กล้อง CCTV</h2>
                <form className="addlight">
                  {cctvs.map((cctv, index) => (
                    <div key={index}>
                      {renderFloatLabelInput(
                        "ชื่อกล้อง",
                        "text",
                        `nameSecondary-${index}`,
                        `nameSecondary-${index}`,
                        cctv.name,
                        (e) => handleCCTVChange(index, "name", e.target.value)
                      )}
                      {renderFloatLabelInput(
                        "รุ่นกล้อง",
                        "text",
                        `modelSecondary-${index}`,
                        `modelSecondary-${index}`,
                        cctv.model,
                        (e) => handleCCTVChange(index, "model", e.target.value)
                      )}
                      {renderFloatLabelInput(
                        "วันที่ติดตั้ง",
                        "date",
                        `installationDateSecondary-${index}`,
                        `installationDateSecondary-${index}`,
                        cctv.installationDate,
                        (e) =>
                          handleCCTVChange(
                            index,
                            "installationDate",
                            e.target.value
                          )
                      )}
                      <div className="flexAddCCtv">
                        <div className="toggle-switch-container">
                          <span>เปิดใช้งานกล้อง</span>
                          <ToggleSwitch
                            checked={cctv.isActive}
                            onChange={() => handleToggleCCTVActive(index)}
                          />
                        </div>
                        <button
                          className="delete-button"
                          onClick={() => handleDeleteCCTV(index)}
                        >
                          <img src={Delete} alt="Delete" />
                        </button>
                      </div>
                    </div>
                  ))}
                </form>
                <button id="addCctvButton" onClick={handleAddCCTV}>
                  + เพิ่มกล้อง CCTV
                </button>
              </div>
            </div>
          )}
          <div className="button-adduser">
            <button className="cancel-button" onClick={onClose}>
              ยกเลิก
            </button>
            <button
              className="confirm-button"
              onClick={() => {
                handleConfirmButtonClick();
              }}
            >
              ถัดไป
            </button>
          </div>
        </div>
      </div>
      {page === 2 && (
        <div className="BranchModal">
          <div className="add-user-modal">
            <h2>เพิ่ม{selectedPoleType === "main" ? "เสาหลัก" : "เสารอง"}</h2>
            <div className="statebranch">
              <Stepper
                className="stepper"
                activeStep={page - 1}
                alternativeLabel
                connector={<CustomConnector activeStep={page - 1} />}
              >
                <Step key="1">
                  <StepLabel StepIconComponent={CustomStepIcon}>
                    เพิ่มข้อมูลเสา
                  </StepLabel>
                </Step>
                <Step key="2">
                  <StepLabel StepIconComponent={CustomStepIcon}>
                    ตรวจสอบข้อมูลเสา
                  </StepLabel>
                </Step>
              </Stepper>
            </div>
            <form className="addlight">
              <strong>
                ข้อมูล{selectedPoleType === "main" ? "สาขา" : "เสาหลัก "}
              </strong>
              <div className="lightSummary">
                <p>
                  {selectedPoleType === "main"
                    ? "รหัสสาขา : "
                    : "รหัสเสาหลัก : "}
                  {selectedPoleType === "main"
                    ? selectedBranch
                      ? selectedBranch.code
                      : "ยังไม่ได้เลือก"
                    : selectedPoles
                    ? selectedPoles.code
                    : "ยังไม่ได้เลือก"}
                </p>
                <p>
                  {selectedPoleType === "main"
                    ? "ชื่อสาขา : "
                    : "ชื่อเสาหลัก : "}
                  {selectedPoleType === "main"
                    ? selectedBranch
                      ? selectedBranch.name
                      : "ยังไม่ได้เลือก"
                    : selectedPoles
                    ? selectedPoles.name
                    : "ยังไม่ได้เลือก"}
                </p>
              </div>
              <strong>
                ข้อมูล{selectedPoleType === "main" ? "เสาหลัก" : "เสารอง"}
              </strong>
              <div className="lightSummary">
                <div className="statusBraunch">
                  {(() => {
                    const { message, style } = getToggleStateMessage();
                    return <p style={style}>{message}</p>;
                  })()}
                </div>
                <div>
                  <p>
                    รหัสเสา:{" "}
                    <label>
                      {selectedPoleType === "main"
                        ? mainPoleData.poleCode
                        : secondaryPoleData.poleCode}
                    </label>
                  </p>
                  <p>
                    ชื่อเสา:{" "}
                    <label>
                      {selectedPoleType === "main"
                        ? mainPoleData.poleName
                        : secondaryPoleData.poleName}
                    </label>
                  </p>
                  <p>
                    รหัสอุปกรณ์:{" "}
                    <label>
                      {selectedPoleType === "main"
                        ? mainPoleData.deviceCode
                        : secondaryPoleData.deviceCode}
                    </label>
                  </p>
                  <p>
                    เวอร์ชั่น Firmware:{" "}
                    <label>
                      {selectedPoleType === "main"
                        ? mainPoleData.firmwareVersion
                        : secondaryPoleData.firmwareVersion}
                    </label>
                  </p>
                  <p>
                    วันที่ติดตั้งเสา:{" "}
                    <label>
                      {selectedPoleType === "main"
                        ? mainPoleData.installationDate
                        : secondaryPoleData.installationDate}
                    </label>
                  </p>
                  <p>
                    สถานที่ติดตั้งเสา:{" "}
                    <label>
                      {selectedPoleType === "main"
                        ? mainPoleData.poleLocation
                        : secondaryPoleData.poleLocation}
                    </label>
                  </p>
                  <p>
                    ละติจูด:{" "}
                    <label>
                      {selectedPoleType === "main"
                        ? mainPoleData.latitude
                        : secondaryPoleData.latitude}
                    </label>
                  </p>
                  <p>
                    ลองจิจูด:{" "}
                    <label>
                      {selectedPoleType === "main"
                        ? mainPoleData.longitude
                        : secondaryPoleData.longitude}
                    </label>
                  </p>
                </div>
              </div>
              <div>
                <strong>ติดตั้งกล้อง CCTV</strong>
                <div className="lightSummaryCCTV">
                  <table className="cctv-table">
                    {cctvs.length > 0 && (
                      <thead className="cctv-table-header">
                        <tr className="cctv-header-row">
                          <th className="cctv-header-cell">No.</th>
                          <th className="cctv-header-cell">ชื่อกล้อง</th>
                          <th className="cctv-header-cell">รุ่นกล้อง</th>
                          <th className="cctv-header-cell">สตรีมคีย์</th>
                          <th className="cctv-header-cell">วันที่ติดตั้ง</th>
                          <th className="cctv-header-cell">สถานะการใช้งาน</th>
                        </tr>
                      </thead>
                    )}
                    <tbody className="cctv-table-body">
                      {cctvs.length > 0 ? (
                        cctvs.map((cctv, index) => {
                          // ตรวจสอบค่า isActive อย่างชัดเจนว่าเป็น true หรือ false
                          const isActiveStatus = cctv.isActive === true;

                          return (
                            <tr key={index} className="cctv-body-row">
                              <td className="cctv-body-cell">{index + 1}</td>
                              <td className="cctv-body-cell">{cctv.name}</td>
                              <td className="cctv-body-cell">{cctv.model}</td>
                              <td className="cctv-body-cell">หลังการบันทึก</td>
                              <td className="cctv-body-cell">
                                {cctv.installationDate}
                              </td>
                              <td
                                className="cctv-body-cell"
                                style={{
                                  color: isActiveStatus ? "#3DCC85" : "#F2274C",
                                  fontWeight: "bold",
                                }}
                              >
                                {isActiveStatus ? "เปิดใช้งาน" : "ปิดการใช้งาน"}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="6" className="cctv-body-cell">
                            ไม่มีการติดตั้งกล้อง CCTV
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              {selectedPoleType === "main" && (
                <div>
                  <strong>ติดตั้งจอ LED</strong>
                  <div className="lightSummaryCCTV">
                    <table className="led-table">
                      {leds.length > 0 && (
                        <thead className="led-table-header">
                          <tr className="led-header-row">
                            <th className="led-header-cell">No.</th>
                            <th className="led-header-cell">รหัสจอ</th>
                            <th className="led-header-cell">รุ่นจอ</th>
                            <th className="led-header-cell">วันที่ติดตั้ง</th>
                            <th className="led-header-cell">สถานะการใช้งาน</th>
                          </tr>
                        </thead>
                      )}
                      <tbody className="led-table-body">
                        {leds.length > 0 ? (
                          leds.map((led, index) => (
                            <tr key={index} className="led-body-row">
                              <td className="led-body-cell">{index + 1}</td>
                              <td className="led-body-cell">{led.name}</td>
                              <td className="led-body-cell">{led.model}</td>
                              <td className="led-body-cell">
                                {led.installationDate}
                              </td>
                              <td className="led-body-cell">
                                {led.has_screen ? "เปิดใช้งาน" : "ปิดการใช้งาน"}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="led-body-cell">
                              ไม่มีการติดตั้งจอ LED
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              <strong>ปรับความสว่างหลอดไฟแบบอัตโนมัติ</strong>
              {selectedPoleType === "main" ? (
                mainPoleData.schedule_light_bulbs_rule === 2 ? (
                  <>
                    <p>กำหนดเอง</p>
                    <div className="chartContainer">
                      <Bar data={chartData} options={options} />
                    </div>
                  </>
                ) : (
                  <p>ใช้ค่าเริ่มต้น</p>
                )
              ) : secondaryPoleData.schedule_light_bulbs_rule === 2 ? (
                <>
                  <p>กำหนดเอง</p>
                  <div className="chartContainer">
                    <Bar data={chartData} options={options} />
                  </div>
                </>
              ) : (
                <p>ใช้ค่าเริ่มต้น</p>
              )}
            </form>
            <div className="button-adduser">
              <button className="cancel-button" onClick={handleCancelClick}>
                ยกเลิก
              </button>
              <button
                className="confirm-button"
                onClick={() => {
                  setIsModalOpen(true);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                ยืนยัน
              </button>
            </div>
          </div>
        </div>
      )}
      {isModalOpen && (
        <div className="BranchModal">
          <div className="lightModalContentSumarry">
            <p>
              ยืนยันการเพิ่มเสา
              <br />"
              {selectedPoleType === "main"
                ? mainPoleData.poleName
                : secondaryPoleData.poleName}
              "
            </p>
            <div className="button-adduser">
              <button
                className="cancel-button"
                onClick={() => {
                  setIsModalOpen(false);
                }}
              >
                ยกเลิก
              </button>
              <button
                className="confirm-button"
                onClick={() => {
                  setIsModalOpen(false);
                  onClose();
                  handleSubmit();
                }}
              >
                ยืนยัน
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AddPoleModal;
